import { api } from '../utils/request'
import { getCookie, setCookie, deleteCookie } from '../utils'
import { Notification } from 'element-ui'

const state = {
  isLogin: getCookie('islogin') === '1' || false,
  email: getCookie('email') || '',
  authMethod: 1, // 1 is google auth, 0 is test login
  uploading: false,
  errorInfo: '',
  fullscreenLoading: false
}
const mutations = {
  setValue (state: any, data: any) {
    state[data.key] = data.value
  }
}
const actions = {
  loginIn ({commit}: any, token = '') {
    commit('setValue', {
      key: 'fullscreenLoading',
      value: true
    })
    api.post(`/login`, {'id_token': token}).then((res: object) => {
      const data = res['data']
      setCookie('email', data['email'], 7)
      setCookie('islogin', '1', 7)
      commit('setValue', {
        key: 'isLogin',
        value: true
      })
      commit('setValue', {
        key: 'email',
        value: data['email']
      })
      commit('setValue', {
        key: 'fullscreenLoading',
        value: false
      })
      if (token) {
        Notification({
          title: 'Login success',
          message: '',
          type: 'success',
          offset: 80,
          duration: 1000
        })
      }
    })
  },
  loginOut ({commit}: any) {
    commit('setValue', {
      key: 'fullscreenLoading',
      value: true
    })
    api.post(`/logout`).then(() => {
      deleteCookie('email')
      deleteCookie('islogin')
      commit('setValue', {
        key: 'isLogin',
        value: false
      })
      commit('setValue', {
        key: 'email',
        value: ''
      })
      commit('setValue', {
        key: 'fullscreenLoading',
        value: false
      })
      Notification({
        title: 'Login out',
        message: ``,
        offset: 80,
        duration: 1000
      })
    })
  },
  setUpload ({commit}: any, val: boolean) {
    commit('setValue', {
      key: 'uploading',
      value: val
    })
  },
  handleError ({commit}: any, msg = '') {
    commit('setValue', {
      key: 'errorInfo',
      value: msg
    })
    Notification.error({
      title: 'Failed',
      message: msg,
      offset: 80
    })
  },
  handlefullLoading ({commit}: any, val: boolean) {
    commit('setValue', {
      key: 'fullscreenLoading',
      value: val
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}